<template>
    <div style="width:100%;height:100%;display: flex;justify-content: center;align-items: center;">
        <!-- <van-loading size="42" type="spinner" color="#1989fa">登录中...</van-loading> -->
        <p>登录中...</p>
    </div>
</template>

<script>
    import {mapActions } from "vuex";
    import {saveLogin, getDdQyId} from "@/api/admin/user";
    import * as dd from 'dingtalk-jsapi'
    import AddRouterFunc from "@/router/addRouter";
    export default {
        name: "ddLogin",
        props: [],
        data() {
            return {
                ddCode:'',
                corpId: ''
            };
        },
        created() {
        },
        mounted(){
            this.getQyId()
        },
        methods: {
            getQyId(){
                getDdQyId().then((res) =>{
                    if(res.data.code == '0'){
                        this.corpId = res.data.data.corpId
                        this.getddCode()
                    }
                }).catch(() =>{})
            },
            getddCode(){
                // if (dd.env.platform !== 'notInDingTalk') {
                    dd.ready(() => {
                        dd.runtime.permission.requestAuthCode({
                            corpId: this.corpId,
                            onSuccess: (info) => {
                                this.ddCode = info.code
                                this.trueLogin()
                            }
                        })
                    })
                // }
            },
            ...mapActions(["setUserToken", "setUserData", "logout", "setAccessToken","bpmnSecurityLoginHandle"]),
            trueLogin(){
                //正常登录
                let params  = {
                    username: 'DINGTALK@' + this.ddCode,
                }
                saveLogin(params).then((res) =>{
                    console.log(res)
                    if ("access_token" in res.data) {
                                this.$store.commit("SET_ACCESS_TOKEN", res.data.access_token)
                                setTimeout(() =>{
                                    // this.$store.commit("SET_ACCESS_TOKEN", res.data.access_token)
                                    // 获取组织部门树
                                    this.$store.dispatch("getDeptTree").then(() => {
                                    }).catch((err) => {
                                        console.log(err)
                                    });
                                    this.bpmnSecurityLoginHandle({
                                        userName:res.data.username,
                                        deviceType:'pc'
                                    }).catch(() => {
                                        // this.$store.commit("SET_ACCESS_TOKEN", null);
                                        // sessionStorage.removeItem('nz_access_token')
                                    });
                                    //获取用户权限
                                    this.$store.dispatch("GetUserPermissions").then((res) => {
                                        //获取个人菜单;
                                        let userInfo = {
                                            deviceType: 'pc',
                                            userId: res.data.sysUser.userId,
                                            userImg: res.data.sysUser.avatar,
                                            userName: res.data.sysUser.username,
                                            deptId: res.data.sysUser.deptId,
                                            roleCodes: res.data.roleCodes,
                                        };
                                        let routerData = res.data.permissions
                                        routerData = [
                                            ...routerData,
                                            '/office',
                                            '/test',
                                            '/statistical/all',
                                            '/ServeCenterDetail',
                                            '/notifyDetail',
                                            '/serveEvaluate',
                                            '/search',
                                            '/noticesAndFilesPagination',
                                            '/fileDetail',
                                            '/teacherTimetable',
                                            '/classRoomTimetable',
                                            '/MySchedule',
                                            '/classTimetable',
                                            '/staff',
                                            '/jobshire',
                                            '/annualappraisal',
                                            '/wage',
                                            '/classroomQuery',
                                            '/grade',
                                            '/teachingInquiry',
                                            '/evaluation',
                                        ]
                                        let newArr = JSON.parse(JSON.stringify(routerData))
                                        if((res.data.roleCodes||[]).includes('ROLE_ADMIN')){
                                            newArr = newArr.concat([
                                                "system-management",
                                                "business-management",
                                                "advices-management",
                                                "efficiency-management",
                                                "data-management",
                                            ])
                                        }
                                        routerData = [...newArr]
                                        this.setUserData({
                                            ...userInfo,
                                            routerData,
                                        });
                                        localStorage.setItem('userData', JSON.stringify({
                                            ...userInfo,
                                            routerData,
                                        }))
                                        sessionStorage.setItem('loginFrom', 'system')
                                        const routers = AddRouterFunc.getNewRouerData(
                                            routerData
                                        );
                                        this.$router.addRoutes(routers);
                                        console.log('到这里了')
                                        this.$router.push('/office');

                                    }).catch((err) => {
                                        console.log(err)
                                    })
                                },1000)
                            }
                }).catch(() =>{})
            }
        },
    };
</script>

<style scoped>

</style>